// Typed accessors for import.meta.env values the SPA reads.
// Vite inlines these at build time; runtime changes need a rebuild.

export const apiBaseUrl: string = import.meta.env.VITE_API_BASE_URL ?? '';
